import React, { memo } from 'react';
import moment from 'moment';
import { StyledFooter, StyledSeparator } from './Footer.Styles';
import { usePage } from '../../';
export var Footer = memo(function (_a) {
    var copyright = _a.copyright, children = _a.children;
    var _b = usePage(), pageShowFooter = _b.pageShowFooter, backgroundImage = _b.page.data.backgroundImage;
    if (!pageShowFooter)
        return null;
    return (React.createElement(StyledFooter, { withContrast: backgroundImage },
        React.createElement(StyledSeparator, null),
        React.createElement("div", null,
            React.createElement("p", null,
                "\u00A9 ",
                moment().format('YYYY'),
                " | ",
                React.createElement("strong", null, copyright)),
            children)));
});
